import React, { Component } from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import { styles } from "./style";
import {
  Paper,
  Grid,
  Button,
  MenuItem,
  Checkbox,
  Typography,
  FormControl,
  FormLabel,
  FormGroup,
  FormControlLabel,
} from "@material-ui/core";
import NumberFormat from "react-number-format";
import moment from "moment";
import queryString, { stringify } from "query-string";
import CryptoJS from "crypto-js";
import sha256 from "sha256";

import Snackbar from "../snackbar";
import NumberFormatCustom from "../numberFormat";
import InputFormat from "../../partials/inputForm";
import Header from "../../partials/header";
import Loading from "../loading";
import {
  ADMIN_URL,
  VNPayConfig,
  ZaloPayConfig,
  isJsonString,
  StripeKey,
} from "../../utils/setting";
class Extend extends Component {
  constructor(props) {
    super(props);
    this.state = {
      paymentMethod: "wallet",
      paymentMonth: 1,
      autoPaymentWallet: 0,
      paymentTypeCard: "creditCard",
      serviceRole: {}, // thông tin service role đang có
      packageList: [],
    };
  }
  async componentDidMount() {
    // Get data from server
    await this.getListPackage();
    await this.findServiceRoleForSpa();
    this.props.getServiceAccount();

    // Handle information from zalopay
    const { i18n, t } = this.props;
    let {
      paymentMethod,
      serviceRole,
      packageList,
      autoPaymentWallet,
      paymentTypeCard,
    } = this.state;
    let servicePackage = packageList.find(
      (item) => item.packageCode == serviceRole.package
    ); // Lấy thông tin package đang sử dụng
    // Redirect from zalopay server
    if (this.props.history.location.search) {
      let zaloPayParams = queryString.parse(this.props.history.location.search);
      let checksumData =
        zaloPayParams.appid +
        "|" +
        zaloPayParams.apptransid +
        "|" +
        zaloPayParams.pmcid +
        "|" +
        zaloPayParams.bankcode +
        "|" +
        zaloPayParams.amount +
        "|" +
        zaloPayParams.discountamount +
        "|" +
        zaloPayParams.status;
      let checksum = CryptoJS.HmacSHA256(
        checksumData,
        ZaloPayConfig.key2
      ).toString();
      if (checksum === zaloPayParams.checksum) {
        let checkStatus = await this.props.getStatusByApptransid({
          apptransid: zaloPayParams.apptransid,
        });
        if (checkStatus.code === 1) {
          //Kiem tra xem du lieu trong db co hop le hay khong va thong bao ket qua
          let price = servicePackage ? servicePackage.price : 1;
          let months = zaloPayParams.amount / price;
          let expired = moment(serviceRole.expired).add(months, "months");
          let data = {
            price: zaloPayParams.amount,
            moduleRole: JSON.stringify(serviceRole.moduleRole),
            expired: new Date(expired).getTime(),
            paymentMethod: paymentMethod,
            autoPaymentWallet: autoPaymentWallet,
            paymentTypeCard: paymentTypeCard,
            package: serviceRole.package,
          };
          let check = await this.props.updateModuleRoleOwner(data);
          if (check.code == 1) {
            this.mSnackbar.handleClick(t("extend_package_success"));
            setTimeout(() => {
              this.props.history.push("/module");
            }, 3000);
          } else {
            this.mSnackbar.handleClick(check.error, "warning");
          }
          // this.props.history.push("/module");
        } else {
          this.mSnackbar &&
            this.mSnackbar.handleClick(checkStatus.error, "error");
        }
      } else {
        this.mSnackbar &&
          this.mSnackbar.handleClick(t("something_went_wrong"), "error");
      }
    }
    // // Redirect from vnpay server
    // if (this.props.history.location.search) {
    //   let vnPayParams = queryString.parse(this.props.history.location.search);
    //   let secureHash = vnPayParams["vnp_SecureHash"];
    //   delete vnPayParams["vnp_SecureHash"];
    //   delete vnPayParams["vnp_SecureHashType"];
    //   let signData =
    //     VNPayConfig.vnp_HashSecret + stringify(vnPayParams, { encode: false });
    //   let checkSum = sha256(signData);
    //   if (secureHash === checkSum) {
    //     //Kiem tra xem du lieu trong db co hop le hay khong va thong bao ket qua
    //     let price = servicePackage ? servicePackage.price : 1;
    //     let months = Number(vnPayParams["vnp_Amount"]) / price;
    //     let expired = moment(serviceRole.expired).add(months, "months");
    //     let data = {
    //       price: vnPayParams["vnp_Amount"],
    //       moduleRole: JSON.stringify(serviceRole.moduleRole),
    //       expired: new Date(expired).getTime(),
    //       paymentMethod: paymentMethod,
    //       autoPaymentWallet: autoPaymentWallet,
    //       paymentTypeCard: paymentTypeCard,
    //       package: serviceRole.package,
    //     };
    //     await this.props.updateModuleRoleOwner(data);
    //     this.props.history.push("/module");
    //   } else {
    //     this.mSnackbar.handleClick(t("something_went_wrong"), "error");
    //   }
    // }
  }
  findServiceRoleForSpa = async () => {
    let _this = this;
    this.loading.startLoading();
    let check = await this.props.findServiceRoleForSpa();
    this.loading.stopLoading();
    if (check.code === 1 && check.data) {
      this.setState({
        serviceRole: check.data,
      });
    }
  };
  getListPackage = async () => {
    let check = await this.props.getListPackage();
    if (check.code === 1) {
      this.setState({
        packageList: check.data,
      });
    }
  };
  actionButton = () => {
    this.props.history.push("/module");
  };
  handleChange = (e) => {
    let state = this.state;
    if (e.target.type === "checkbox") {
      e.target.value = e.target.checked ? 1 : 0;
    }
    state[e.target.name] = e.target.value;
    this.setState(state);
  };
  handleChangeTypeCard = (e) => {
    let paymentTypeCard = this.state.paymentTypeCard;
    paymentTypeCard = e.target.name;
    this.setState({ paymentTypeCard });
  };
  handlePayment = async () => {
    this.loading.startLoading();
    const { i18n, t, serviceAccount, setting } = this.props;
    let {
      paymentMethod,
      serviceRole,
      packageList,
      paymentMonth,
      autoPaymentWallet,
      paymentTypeCard,
    } = this.state;
    let servicePackage = packageList.find(
      (item) => item.packageCode == serviceRole.package
    ); // Lấy thông tin package đang sử dụng
    let price = servicePackage ? servicePackage.price : 0;
    let expired = moment(serviceRole.expired).add(paymentMonth, "months");
    let data = {
      price: price * paymentMonth,
      moduleRole: JSON.stringify(serviceRole.moduleRole),
      expired: new Date(expired).getTime(),
      paymentMethod: paymentMethod,
      autoPaymentWallet: autoPaymentWallet,
      paymentTypeCard: paymentTypeCard,
      package: serviceRole.package,
    };
    if (paymentMethod == "wallet") {
      if (serviceAccount.balance >= price * paymentMonth) {
        let check = await this.props.updateModuleRoleOwner(data);
        this.loading.stopLoading();
        if (check.code == 1) {
          this.mSnackbar.handleClick(t("extend_package_success"));
          setTimeout(() => {
            this.props.history.push("/module");
          }, 3000);
        } else {
          this.mSnackbar.handleClick(check.error, "warning");
        }
      } else {
        this.loading.stopLoading();
        this.mSnackbar.handleClick(
          t("extend_wallet_not_enough_money"),
          "warning"
        );
      }
    } else {
      // ZaloPay
      let returnUrl = `${ADMIN_URL}/module/extend`;
      this.props.createPaymentZaloPay({
        amount: data.price,
        info: "CHANGE_PACKAGE",
        paymentTypeCard: paymentTypeCard,
        currency: setting.currencyCode,
        returnUrl: returnUrl,
      });
      this.loading.stopLoading();
      // // VNPAY
      // let locale = i18n.language == "vn" ? "vn" : "en";
      // let currency = "VND";
      // let returnUrl = `${ADMIN_URL}/module/extend`;
      // await this.props.createPaymentVNPay({
      //   amount: data.price,
      //   info: "CHANGE_PACKAGE",
      //   locale: locale,
      //   currency: currency,
      //   returnUrl: returnUrl,
      // });
      // this.loading.stopLoading();
    }
  };
  render() {
    const { classes, t, serviceAccount, setting } = this.props;
    let {
      paymentMethod,
      serviceRole,
      packageList,
      paymentMonth,
      autoPaymentWallet,
      paymentTypeCard,
    } = this.state;
    let servicePackage = packageList.find(
      (item) => item.packageCode == serviceRole.package
    ); // Lấy thông tin package đang sử dụng
    let price = servicePackage ? servicePackage.price : 0;
    let balance =
      serviceAccount && serviceAccount.balance ? serviceAccount.balance : 0;
    if (isJsonString(setting.paymentMethod)) {
      setting.paymentMethod = JSON.parse(setting.paymentMethod);
    }
    return (
      <React.Fragment>
        <Header
          session={t("sidebar_manage")}
          title={t("extend")}
          backIcon={true}
          actionBack={() => this.actionButton()}
        />
        <Paper className={classes.root}>
          <Snackbar onRef={(snackbar) => (this.mSnackbar = snackbar)} />
          <Loading onRef={(id) => (this.loading = id)} />
          <form className={classes.container} noValidate autoComplete="off">
            <Grid container spacing={3}>
              <Grid item xs={12} sm={12}>
                <InputFormat
                  required
                  select
                  label={t("extend_pament_method")}
                  name="paymentMethod"
                  margin="normal"
                  fullWidth
                  value={paymentMethod}
                  onChange={this.handleChange}
                  className={classes.textField}
                  InputProps={{
                    fullWidth: true,
                    className: classes.input,
                  }}
                  SelectProps={{
                    MenuProps: {
                      className: classes.menu,
                    },
                  }}
                  InputLabelProps={{
                    className: classes.label,
                  }}
                >
                  <MenuItem value={"wallet"}>{t("extend_wallet")}</MenuItem>
                  <MenuItem value={"card"}>{t("extend_card")}</MenuItem>
                </InputFormat>
                {paymentMethod === "wallet" && (
                  <NumberFormat
                    value={balance}
                    thousandSeparator
                    displayType="text"
                    renderText={(value) => (
                      <Typography>
                        {t("extend_balance")}: {value}
                      </Typography>
                    )}
                  />
                )}
              </Grid>
              <Grid item xs={9} sm={9}>
                <InputFormat
                  required
                  disabled
                  label={t("extend_price_package")}
                  margin="normal"
                  value={price * paymentMonth}
                  className={classes.textField}
                  InputProps={{
                    inputComponent: NumberFormatCustom,
                    classes: {
                      inputType: classes.inputType,
                    },
                  }}
                  InputLabelProps={{
                    className: classes.label,
                  }}
                />
              </Grid>
              <Grid item xs={3} sm={3}>
                <InputFormat
                  required
                  select
                  label={t("extend_month_number")}
                  name="paymentMonth"
                  margin="normal"
                  fullWidth
                  value={paymentMonth}
                  onChange={this.handleChange}
                  className={classes.textField}
                  InputProps={{
                    fullWidth: true,
                    className: classes.input,
                  }}
                  SelectProps={{
                    MenuProps: {
                      className: classes.menu,
                    },
                  }}
                  InputLabelProps={{
                    className: classes.label,
                  }}
                >
                  <MenuItem value={1}>{`1 ${t("extend_month")}`}</MenuItem>
                  <MenuItem value={3}>{`3 ${t("extend_month")}`}</MenuItem>
                  <MenuItem value={6}>{`6 ${t("extend_month")}`}</MenuItem>
                </InputFormat>
              </Grid>
              <Grid item xs={12} sm={12}>
                {paymentMethod === "wallet" ? (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={autoPaymentWallet == 1 ? true : false}
                        name="autoPaymentWallet"
                        onChange={this.handleChange}
                      />
                    }
                    className={classes.label}
                    label={t("extend_auto_payment_wallet")}
                  />
                ) : (
                  <React.Fragment>
                    {setting.paymentMethod.indexOf("vietNamPayment") != -1 && (
                      <FormControl
                        component="fieldset"
                        className={classes.formControl}
                      >
                        <FormGroup>
                          <img
                            src={"/images/creditCard.svg"}
                            className={classes.iconCard}
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={
                                  paymentTypeCard == "creditCard" ? true : false
                                }
                                name="creditCard"
                                onChange={this.handleChangeTypeCard}
                              />
                            }
                            className={classes.label}
                            label={t("extend_credit_card")}
                          />
                        </FormGroup>
                      </FormControl>
                    )}
                    {setting.paymentMethod.indexOf("stripe") != -1 && (
                      <FormControl
                        component="fieldset"
                        className={classes.formControl}
                      >
                        <FormGroup>
                          <img
                            src={"/images/visaCard.svg"}
                            className={classes.iconCard}
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={
                                  paymentTypeCard == "visaCard" ? true : false
                                }
                                name="visaCard"
                                onChange={this.handleChangeTypeCard}
                              />
                            }
                            className={classes.label}
                            label={t("extend_credit_card")}
                          />
                        </FormGroup>
                      </FormControl>
                    )}
                  </React.Fragment>
                )}
              </Grid>
              <Grid item xs={12} sm={12} alignItems="flex-end">
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.button}
                  onClick={this.handlePayment}
                >
                  {t("extend_next_button")}
                </Button>
              </Grid>
              <Grid item xs={12} sm={12}>
                Lưu ý: Sau khi hoàn tất thanh toán, Quý đối tác vui lòng kiểm
                tra lại mục Thanh Toán xem đơn hàng đã thanh toán thành công hay
                chưa? Thông thường sau khi hoàn tất thanh toán, tiền sẽ được nạp
                vào ID liền trong 1-15 phút. Sau thời gian này nếu tài khoản ID
                không có tiền quý khách vui lòng liên hệ ngay bộ phận kinh doanh
                của chúng tôi để kiểm tra. HCM: +84 (28) 36229999 , HN: +84 (24)
                35123456 (Giờ hành chính) hoặc Hotline 19001830 (24/7).
              </Grid>
            </Grid>
          </form>
        </Paper>
      </React.Fragment>
    );
  }
}
const mapState = (state) => ({
  serviceAccount: state.serviceAccount.serviceAccount,
  setting: state.setting.setting,
});

const mapDispatch = (dispatch) => ({
  getServiceAccount: dispatch.serviceAccount.getServiceAccount,
  findServiceRoleForSpa: dispatch.serviceRole.findServiceRoleForSpa,
  updateModuleRoleOwner: dispatch.serviceRole.updateModuleRoleOwner,
  getListPackage: dispatch.packages.getListPackage,
  createPaymentVNPay: dispatch.serviceAccount.createPaymentVNPay,
  createPaymentZaloPay: dispatch.serviceAccount.createPaymentZaloPay,
  getStatusByApptransid: dispatch.serviceAccount.getStatusByApptransid,
});
export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles, { withTheme: true })(Extend)));
